function reducer(state = [], action) {

    switch (action.type) {
        case 'PAST_DUES/SET':
            return action.pastDues;
        default:
            return state;
    }
}

export default reducer;